import { createSelector } from 'reselect';
import { KEY, WillCallState } from './types';
import { GlobalState } from 'store/types';

const getWillCallState = (state: GlobalState) => state[KEY] as WillCallState;

const selectOrderDetails = createSelector(
  getWillCallState,
  willCall => willCall.orderDetails
);

const selectCustomer = createSelector(
  getWillCallState,
  willCall => willCall.customer
);

const selectLoading = createSelector(
  getWillCallState,
  willCall => willCall.loading
);

const selectError = createSelector(
  getWillCallState,
  willCall => willCall.error
);

const selectedLookupOption = createSelector(
  getWillCallState,
  willCall => willCall.selectedLookupOption
);

const selectOrdersList = createSelector(
  getWillCallState,
  willCall => willCall.ordersList
);

export const selectors = {
  selectOrderDetails,
  selectCustomer,
  selectLoading,
  selectError,
  selectedLookupOption,
  selectOrdersList
};
